<template>
  <div class="loading">
    <div class="gf_section_page_info skeleton skeleton-light"></div>
    <div class="gf_pricing__plan__row row">
      <div class="gf_pricing" :class="colNum === 4 ? 'col-3' : 'col-4' " v-for="col in colNum" :key="col">
        <div class="col skeleton skeleton-light"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {PLAN_NO} from "@/contants/plan";

export default {
  name: "PricingPageLoading",
  computed: {
    ...mapState("account", {
      plan: (state) => state.shopInfo.plan,
    }),
    colNum() {
      if (this.plan === PLAN_NO.TRIAL2022 || this.plan === PLAN_NO.STARTER || this.plan === PLAN_NO.TRIAL) {
        return 4
      }

      return 3
    }
  }
}
</script>

<style scoped lang="scss">
.row {
  height: 431px;
  margin-top: 32px;
}

.loading {
  .gf_section_page_info {
    width: 692px;
    height: 204px;
    background: #F4F4F4;
    border-radius: 3px;
  }

  .gf_pricing {
    border-radius: 3px;

    .col {
      background: #F4F4F4;
      height: 100%;
    }
  }
}
</style>
